var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQrCode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.94336 9.23698V1.94531H9.23503V9.23698H1.94336ZM2.98503 8.19531H8.19336V2.98698H2.98503V8.19531ZM1.94336 18.612V11.3203H9.23503V18.612H1.94336ZM2.98503 17.5703H8.19336V12.362H2.98503V17.5703ZM11.3184 9.23698V1.94531H18.61V9.23698H11.3184ZM12.36 8.19531H17.5684V2.98698H12.36V8.19531ZM16.7871 18.612V16.7891H18.61V18.612H16.7871ZM11.3184 13.1432V11.3203H13.1413V13.1432H11.3184ZM13.1413 14.9661V13.1432H14.9642V14.9661H13.1413ZM11.3184 16.7891V14.9661H13.1413V16.7891H11.3184ZM13.1413 18.612V16.7891H14.9642V18.612H13.1413ZM14.9642 16.7891V14.9661H16.7871V16.7891H14.9642ZM14.9642 13.1432V11.3203H16.7871V13.1432H14.9642ZM16.7871 14.9661V13.1432H18.61V14.9661H16.7871Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrCode);
export default __webpack_public_path__ + "static/media/qr-code.f1b722734b740595f2601d388123b3dd.svg";
export { ForwardRef as ReactComponent };